// Terms and Conditions Templates - 4 Types
export const termsTemplateOptions = {
  salesTerms: {
    singleLiner: `Payment due in 30 days. No returns after 7 days. Subject to [City] jurisdiction.`,
    
    smallPara: `Payment Terms: Payment is due within 30 days from invoice date. Late payment charges @ 1.5% per month will be applicable after due date. Delivery: Goods will be delivered within 7-15 days from order confirmation. Returns: No returns accepted after 7 days of delivery. Returns only for damaged/defective items. All disputes subject to [City] jurisdiction.`,
    
    mediumPointer: `Terms & Conditions for Sales:
• Payment due within 30 days from invoice date
• Late payment charges @ 1.5% per month after due date
• Delivery within 7-15 days from order confirmation
• No returns after 7 days of delivery
• Returns only for damaged/defective items
• All disputes subject to [City] jurisdiction
• Risk of loss transfers to buyer upon delivery
• Warranty period: 1 year from date of delivery`,
    
    professional: `TERMS & CONDITIONS FOR SALES

1. PAYMENT TERMS:
   - Payment is due within 30 days from invoice date
   - Late payment charges @ 1.5% per month will be applicable after due date
   - All payments to be made in favor of [Company Name]
   - Payment through NEFT/RTGS/Cheque only

2. DELIVERY TERMS:
   - Goods will be delivered within 7-15 days from order confirmation
   - Risk of loss transfers to buyer upon delivery
   - Delivery charges extra if applicable
   - Partial deliveries acceptable with prior consent

3. QUALITY & WARRANTY:
   - All goods are subject to quality inspection
   - Warranty period: 1 year from date of delivery
   - Defective goods will be replaced within warranty period
   - Warranty covers manufacturing defects only

4. RETURNS & REFUNDS:
   - No returns accepted after 7 days of delivery
   - Returns only for damaged/defective items
   - Refunds processed within 15 days of return approval
   - Return shipping charges to be borne by buyer

5. DISPUTE RESOLUTION:
   - All disputes subject to [City] jurisdiction
   - Governing law: Indian Contract Act, 1872
   - Arbitration through [Arbitration Center]

6. FORCE MAJEURE:
   - Company not liable for delays due to circumstances beyond control
   - Natural disasters, government actions, labor disputes excluded

For any queries, contact us at [Phone] or [Email]`
  },

  purchaseTerms: {
    singleLiner: `Payment as per agreed terms. Quality inspection within 7 days. Valid GST required.`,
    
    smallPara: `Order Confirmation: All purchase orders subject to written confirmation. Prices valid for 30 days from quotation date. Payment Terms: Payment as per agreed terms (Net 30/45/60 days). Quality Standards: Goods must meet specified quality standards. Quality inspection within 7 days of delivery. Documentation: Valid GST registration certificate required. Subject to [City] jurisdiction.`,
    
    mediumPointer: `Purchase Terms & Conditions:
• All orders subject to written confirmation
• Prices valid for 30 days from quotation date
• Payment as per agreed terms (Net 30/45/60 days)
• Quality inspection within 7 days of delivery
• Valid GST registration certificate required
• Delivery as per agreed schedule
• Packing suitable for transport required
• Non-conforming goods will be rejected
• Subject to [City] jurisdiction`,
    
    professional: `PURCHASE TERMS & CONDITIONS

1. ORDER CONFIRMATION:
   - All purchase orders subject to written confirmation
   - Prices valid for 30 days from quotation date
   - Minimum order quantity may apply
   - Order modifications require written approval

2. PAYMENT TERMS:
   - Payment as per agreed terms (Net 30/45/60 days)
   - Advance payment may be required for new suppliers
   - Payment through NEFT/RTGS/Cheque only
   - Late payment charges @ 1.5% per month

3. DELIVERY REQUIREMENTS:
   - Delivery as per agreed schedule
   - Packing must be suitable for transport
   - Delivery challan and invoice required
   - Partial deliveries acceptable with prior consent

4. QUALITY STANDARDS:
   - Goods must meet specified quality standards
   - Quality inspection within 7 days of delivery
   - Non-conforming goods will be rejected
   - Quality certificates required if applicable

5. DOCUMENTATION:
   - Valid GST registration certificate required
   - Proper invoices with GST details
   - Quality certificates if applicable
   - Material safety data sheets for chemicals

6. TERMS OF AGREEMENT:
   - These terms override any conflicting terms
   - Subject to [City] jurisdiction
   - Governing law: Indian Contract Act, 1872
   - Force majeure clause applicable

Contact: [Phone] | [Email]`
  },

  quotationTerms: {
    singleLiner: `Valid for 30 days. 50% advance required. Prices exclusive of GST.`,
    
    smallPara: `Validity: This quotation is valid for 30 days from date of issue. Prices subject to change without prior notice. Pricing: Prices are exclusive of GST unless specified. Currency: Indian Rupees (INR). Payment Terms: 50% advance on order confirmation. Balance on delivery/completion. Delivery: Delivery time: 15-30 days from order confirmation. Order confirmation required in writing. Subject to [City] jurisdiction.`,
    
    mediumPointer: `Quotation Terms & Conditions:
• Valid for 30 days from date of issue
• Prices exclusive of GST unless specified
• 50% advance on order confirmation
• Balance on delivery/completion
• Delivery time: 15-30 days from order confirmation
• Order confirmation required in writing
• Prices subject to change without prior notice
• Custom requirements subject to additional charges
• Subject to [City] jurisdiction`,
    
    professional: `QUOTATION TERMS & CONDITIONS

1. VALIDITY:
   - This quotation is valid for 30 days from date of issue
   - Prices subject to change without prior notice
   - Valid only for the quantities specified
   - Extension of validity subject to written approval

2. PRICING:
   - Prices are exclusive of GST unless specified
   - Additional charges for special requirements
   - Currency: Indian Rupees (INR)
   - Price escalation clause for long-term contracts

3. DELIVERY:
   - Delivery time: 15-30 days from order confirmation
   - Delivery charges extra if applicable
   - Partial deliveries acceptable
   - Delivery schedule subject to material availability

4. PAYMENT TERMS:
   - 50% advance on order confirmation
   - Balance on delivery/completion
   - Payment through NEFT/RTGS/Cheque
   - Late payment charges @ 1.5% per month

5. SPECIFICATIONS:
   - As per technical specifications provided
   - Minor variations acceptable within 5%
   - Custom requirements subject to additional charges
   - Design changes require written approval

6. TERMS & CONDITIONS:
   - Order confirmation required in writing
   - These terms override any conflicting terms
   - Subject to [City] jurisdiction
   - Governing law: Indian Contract Act, 1872

7. FORCE MAJEURE:
   - Not liable for delays due to circumstances beyond control
   - Natural disasters, government actions excluded

For detailed specifications, contact us at [Phone] or [Email]`
  },

  footer: {
    singleLiner: `Thank you for your business! Contact: [Phone] | [Email]`,
    
    smallPara: `Thank you for your business! For any queries, contact us at [Phone] or [Email]. GST: [Your GST Number] | PAN: [Your PAN Number]. This is a computer generated document.`,
    
    mediumPointer: `Thank you for your business!

Contact Information:
• Phone: [Your Phone Number]
• Email: [Your Email Address]
• Website: [Your Website]

Legal Information:
• GST: [Your GST Number]
• PAN: [Your PAN Number]
• This is a computer generated document`,
    
    professional: `Thank you for your business!

For any queries or support, please contact us:
📞 Phone: [Your Phone Number]
📧 Email: [Your Email Address]
🌐 Website: [Your Website]
📍 Address: [Your Complete Address]

Legal Information:
GST Registration: [Your GST Number]
PAN: [Your PAN Number]
CIN: [Your CIN Number] (if applicable)

Important Notes:
• This is a computer generated document and does not require signature
• All terms and conditions are subject to [City] jurisdiction
• Governing law: Indian Contract Act, 1872
• For disputes, contact us within 30 days

© 2024 [Your Company Name]. All rights reserved.

This document is confidential and intended solely for the use of the addressee.`
  }
};

// Default template data for terms and conditions (using professional templates)
export const defaultTermsTemplates = {
  salesTerms: termsTemplateOptions.salesTerms.professional,
  purchaseTerms: termsTemplateOptions.purchaseTerms.professional,
  quotationTerms: termsTemplateOptions.quotationTerms.professional,
  footer: termsTemplateOptions.footer.professional
};